


























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateUser from './create-user.vue'
import EditUser from './edit-user.vue'
import ResetUser from './reset-user.vue'
import Recharge from './systemrecharge.vue'
import Enums from '@/lib/enums'
class  PageUserRequest extends PageRequest{
    keyword:string;
    isActive:boolean=null;//nullable
    from:Date;
    to: Date;
    userCode: string;
    phone: string;
}

@Component({
     name:"user",
    components: { CreateUser, EditUser, ResetUser, Recharge}
})
export default class Users extends AbpBase{
    edit(){
        this.editModalShow=true;
    }
    //filters
    pagerequest:PageUserRequest=new PageUserRequest();
    creationTime:Date[]=[];
    createModalShow:boolean=false;
    editModalShow: boolean = false;
    resetModalShow: boolean = false;
    isRole: Boolean = this.hasPermission('Pages.Roles');
    rechargeModalShow: boolean = false;
    get list(){
        return this.$store.state.user.list;
    };
    get loading(){
        return this.$store.state.user.loading;
    }
    create(){
        this.createModalShow=true;
    }
    reset() {
        this.resetModalShow = true;
    }
    isActiveChange(val:string){
        console.log(val);
        if(val==='Actived'){
            this.pagerequest.isActive=true;
        }else if(val==='NoActive'){
            this.pagerequest.isActive=false;
        }else{
            this.pagerequest.isActive=null;
        }
    }
    pageChange(page:number){
        this.$store.commit('user/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('user/setPageSize',pagesize);
        this.getpage();
    }

    async searchPage() {
        this.$store.state.user.currentPage=1;
        this.getpage();
    }
    recharege(data: any) {
        this.$store.state.user.id = data.id;
        this.$store.state.user.userCode = data.userCode;
        this.rechargeModalShow = true;
    }
    async getpage(){
      
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        //filters
        
        if (this.creationTime.length>0) {
            this.pagerequest.from=this.creationTime[0];
        }
        if (this.creationTime.length>1) {
            this.pagerequest.to=this.creationTime[1];
        }

        await this.$store.dispatch({
            type:'user/getAll',
            data:this.pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.user.pageSize;
    }
    get totalCount(){
        return this.$store.state.user.totalCount;
    }
    get currentPage(){
        return this.$store.state.user.currentPage;
    }
    columns=[{
        title:this.L('账号'),
        key:'userName'
    },{
        title:this.L('用户名称'),
        key:'name'
    },{
        title:this.L('是否有效'),
        render:(h:any,params:any)=>{
           return h('span',params.row.isActive?this.L('是'):this.L('否'))
        }
    },{
        title:this.L('创建时间'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h('span',new Date(params.row.creationTime).toLocaleDateString())
        }
    },{
        title:this.L('手机号码'),
        key:'phone',
    },{
        title:this.L('微信'),
        key:'weChat',
    },{
        title:this.L('用户编码'),
        key:'userCode',
        },
        {
            title: this.L('用户类别'),
            key: 'userType',
            render: (h: any, params: any) => {
                return h('span', Enums.UserType.filter(function (item) { return item.value == params.row.userType })[0].name);
            }
        },
        {
        title:this.L('用户积分'),
        key:'amount',
    },{
        title:this.L('操作'),
        key:'Actions',
        width:240,
            render: (h: any, params: any) => {
                var data = params.row;
            return h('div', [
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    style: {
                        marginRight: '5px',
                        display: this.isRole ? "inline-block" : "none",
                    },
                    on: {
                        click: () => {

                            this.recharege(params.row);
                        }
                    }
                }, this.L('充值')),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    style: {
                        marginRight: '5px'
                    },
                    on: {
                        click: () => {
                            this.$store.state.user.id = data.id = data.id;
                            this.reset();
                        }
                    }
                }, this.L('重置密码')),
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('user/edit',params.row);
                            this.edit();
                        }
                    }
                },this.L('修改')),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('DeleteUserConfirm'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'user/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L('删除'))
            ])
        }
    }]
    async created(){
        this.getpage();
        await this.$store.dispatch({
            type:'user/getRoles'
        })
    }
}
